<div class="customer-info">
  <div class="customer-info-row multiple-controls">
    <div class="g-form-control">
      <div class="g-form-label">
        {{ 'customer_info.phone_number' | translate }}
      </div>

      <div class="form-input-container">
        <div
          class="g-form-input"
          [class.g-form-input-invalid]="isControlInvalid('phoneNumber')"
          [class.disabled]="!!customerService.customer().contactInfo.phoneNumber"
          (click)="onPhoneNumberInputClick()"
        >
          {{ customerService.customer().contactInfo.phoneNumber | mask:PHONE_NUMBER_MASK }}
        </div>

        @if (customerService.customer().contactInfo.phoneNumber && !customerService.customer().contactInfo.isPhoneNumberConfirmed) {
          <button
            class="g-form-control-button"
            type="button"
            (click)="onConfirmPhoneNumber()"
            [matTooltip]="'customer_info.confirm_phone_number' | translate"
            matTooltipPosition="above"
          >
            <tc-icon name="check-circle" />
          </button>
        }

        <button
          class="g-form-control-button"
          type="button"
          (click)="onChangePhoneNumber()"
          [matTooltip]="'customer_info.change_phone_number' | translate"
          matTooltipPosition="above"
        >
          <tc-icon name="edit" />
        </button>
      </div>

      @if (isControlInvalid('phoneNumber')) {
        <div class="g-form-control-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>

    <div class="g-form-control">
      <div class="g-form-label">
        {{ 'global.email' | translate }} @if (!customerService.customer().contactInfo.email) { <span class="form-label-unrequired">({{ 'customer_info.unrequired' | translate }})</span> }
      </div>

      <div class="form-input-container">
        <div
          class="g-form-input"
          [class.g-form-input-invalid]="isControlInvalid('email')"
          [class.disabled]="!!customerService.customer().contactInfo.email"
          (click)="onEmailInputClick()"
        >
          {{ customerService.customer().contactInfo.email }}
        </div>

        @if (customerService.customer().contactInfo.email && !customerService.customer().contactInfo.isEmailConfirmed) {
          <button
            class="g-form-control-button"
            type="button"
            (click)="onConfirmEmail()"
            [matTooltip]="'customer_info.confirm_email' | translate"
            matTooltipPosition="above"
          >
            <tc-icon name="check-circle" />
          </button>
        }

        <button
          class="g-form-control-button"
          type="button"
          (click)="onChangeEmail()"
          [matTooltip]="'customer_info.change_email' | translate"
          matTooltipPosition="above"
        >
          <tc-icon name="edit" />
        </button>
      </div>

      @if (isControlInvalid('email')) {
        <div class="g-form-control-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>
  </div>

  <div class="customer-info-row">
    <div class="g-form-control">
      <div class="g-form-label">
        {{ 'customer_info.full_name' | translate }}
      </div>

      <div class="form-input-container">
        <div
          class="g-form-input"
          [class.g-form-input-invalid]="isControlInvalid('name')"
          [class.disabled]="!!customerService.customer().contactInfo.lastName && !!customerService.customer().contactInfo.firstName"
          (click)="onNameInputClick()"
        >
          {{ customerService.customer().contactInfo.lastName + ' ' + customerService.customer().contactInfo.firstName + ' ' + customerService.customer().contactInfo.middleName }}
        </div>

        <button
          class="g-form-control-button"
          type="button"
          (click)="onChangeName()"
          [matTooltip]="'customer_info.change_name' | translate"
          matTooltipPosition="above"
        >
          <tc-icon name="edit" />
        </button>
      </div>

      @if (isControlInvalid('name')) {
        <div class="g-form-control-error">
          {{ 'global.required_field' | translate }}
        </div>
      }
    </div>
  </div>
</div>
